var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TemplateRef, EventEmitter } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { AbstractDwFormItemComponent } from '../../../../../../projects/webdpt/framework/components/form-field/abstract-dw-form-item-component';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import { TranslateParser } from '@ngx-translate/core';
var FxNumberFormatComponent = /** @class */ (function (_super) {
    __extends(FxNumberFormatComponent, _super);
    function FxNumberFormatComponent(_fg, _ts, fxUserService) {
        var _this = _super.call(this, _fg, _ts) || this;
        _this._fg = _fg;
        _this._ts = _ts;
        _this.fxUserService = fxUserService;
        _this.dwDisabled = false;
        _this.dwCompact = false;
        _this.dwSearch = false;
        _this.dwType = 'default'; // 小数位数类别
        _this.dwCode = 'default'; // 小数位代码
        _this.dwHasZero = false; // 是否允许输入00开头的数值
        // @Output() dwValueChange = new EventEmitter<any>();
        _this.dwBlur = new EventEmitter();
        _this.dwClick = new EventEmitter();
        _this.defaultDecimal = null;
        _this.decimal = null;
        _this.defaultRoundType = null;
        _this.roundType = null;
        _this.oldDwValue = ''; // 记录旧值
        return _this;
    }
    FxNumberFormatComponent.prototype.afterContentInit = function () { };
    FxNumberFormatComponent.prototype.change = function (event) {
        this.ngModelChange(event, true);
        this.onChange(this.dwValue);
    };
    FxNumberFormatComponent.prototype.ngModelChange = function ($event, isSetNewValue) {
        if (this.dwHasZero) {
            this.dwValue = this.dwValue.replace(/\D/g, '');
            this.oldDwValue = this.dwValue;
        }
        else if (this.dwPositiveNum >= 0) {
            var reg1 = '^(\\d|([1-9]\\d+))(\\.\\d{0,' + this.dwPositiveNum + '})?$';
            // 等于0时，改判断大于等于0的整数
            if (this.dwPositiveNum === 0) {
                var reg1 = '^(\\d|([1-9]\\d+))?$';
            }
            if (new RegExp(reg1).test(this.dwValue) !== true && this.dwValue && isSetNewValue) {
                this.dwValue = this.oldDwValue;
            }
            else {
                if (((this.dwMin !== undefined && this.dwValue < this.dwMin) || (this.dwMin !== undefined && this.dwValue > this.dwMax)) && this.dwValue && isSetNewValue) {
                    this.dwValue = this.oldDwValue;
                }
                else {
                    this.oldDwValue = this.dwValue;
                }
            }
        }
        else if (this.dwNegtiveNum >= 0) {
            var reg2 = '^(-|-?(\\d|([1-9]\\d+)))(\\.\\d{0,' + this.dwNegtiveNum + '})?$';
            // 等于0时，改判断大于等于0的整数
            if (this.dwNegtiveNum === 0) {
                var reg2 = '^(-|-?(\\d|([1-9]\\d+)))?$';
            }
            if (new RegExp(reg2).test(this.dwValue) !== true && this.dwValue && isSetNewValue) {
                this.dwValue = this.oldDwValue;
            }
            else {
                if (((this.dwMin !== undefined && this.dwValue < this.dwMin) || (this.dwMin !== undefined && this.dwValue > this.dwMax)) && this.dwValue && isSetNewValue) {
                    this.dwValue = this.oldDwValue;
                }
                else {
                    this.oldDwValue = this.dwValue;
                }
            }
        }
        else {
            var reg3 = '^(\\d|([1-9]\\d+))(\\.\\d{0,' + this.decimal + '})?$';
            if (this.decimal == 0) {
                var reg3 = '^(\\d|([1-9]\\d+))?$';
            }
            if (new RegExp(reg3).test(this.dwValue) !== true && this.dwValue && isSetNewValue) {
                this.dwValue = this.oldDwValue;
            }
            else {
                if (((this.dwMin !== undefined && this.dwValue < this.dwMin) || (this.dwMin !== undefined && this.dwValue > this.dwMax)) && this.dwValue && isSetNewValue) {
                    this.dwValue = this.oldDwValue;
                }
                else {
                    this.oldDwValue = this.dwValue;
                }
            }
        }
        // this.dwValueChange.emit(this.dwValue);
    };
    FxNumberFormatComponent.prototype.blur = function ($event) {
        // this.ngModelChange($event, true)
        this.dwBlur.emit($event);
    };
    FxNumberFormatComponent.prototype.click = function ($event) {
        this.dwClick.emit($event);
    };
    Object.defineProperty(FxNumberFormatComponent.prototype, "value", {
        get: function () {
            return this.dwValue;
        },
        set: function (value) {
            if (value !== this.dwValue) {
                this.dwValue = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    FxNumberFormatComponent.prototype.onInit = function () {
        var items = [];
        if (this.dwType === 'unit') {
            items = this.fxUserService.getUnitParam([]);
        }
        else if ((['amountDecimal', 'priceDecimal'])
            .indexOf(this.dwType) !== -1) {
            items = this.fxUserService.getCurrencyParam([]);
        }
        for (var i = 0; i < items.length; i++) {
            var val = items[i];
            if (val.bacunit) {
                if (val.bacunit === 'default') {
                    this.defaultDecimal = val.bac002;
                    this.defaultRoundType = val.bac003;
                }
                if (val.unit === this.dwCode) {
                    this.decimal = val.bac002;
                    this.roundType = val.bac003;
                }
            }
            else {
                if (val.baacurr === 'default') {
                    switch (this.dwType) {
                        case 'amountDecimal':
                            this.defaultDecimal = val.baa001;
                            this.defaultRoundType = val.baa003;
                            break;
                        case 'priceDecimal':
                            this.defaultDecimal = val.baa002;
                            this.defaultRoundType = val.baa003;
                            break;
                        default:
                            break;
                    }
                }
                if (val.baacurr === this.dwCode) {
                    switch (this.dwType) {
                        case 'amountDecimal':
                            this.decimal = val.baa001;
                            this.roundType = val.baa003;
                            break;
                        case 'priceDecimal':
                            this.decimal = val.baa002;
                            this.roundType = val.baa003;
                            break;
                        default:
                            break;
                    }
                }
            }
        }
        // items.forEach(function (val) {
        // if (val.bacunit) {
        //   if (val.bacunit === 'default') {
        //     this.defaultDecimal = val.bac002;
        //     this.defaultRoundType = val.bac003;
        //   }
        //   if (val.unit === this.dwCode) {
        //     this.decimal = val.bac002;
        //     this.roundType = val.bac003;
        //   }
        // } else {
        //   if (val.baacurr === 'default') {
        //     switch (this.dwType) {
        //       case 'amountDecimal':
        //         this.defaultDecimal = val.baa001;
        //         this.defaultRoundType = val.baa003;
        //         break;
        //       case 'priceDecimal':
        //         this.defaultDecimal = val.baa002;
        //         this.defaultRoundType = val.baa003;
        //         break;
        //       default:
        //         break;
        //     }
        //   }
        //   if (val.baacurr === this.dwCode) {
        //     switch (this.dwType) {
        //       case 'amountDecimal':
        //         this.decimal = val.baa001;
        //         this.roundType = val.baa003;
        //         break;
        //       case 'priceDecimal':
        //         this.decimal = val.baa002;
        //         this.roundType = val.baa003;
        //         break;
        //       default:
        //         break;
        //     }
        //   }
        // }
        // });
        if (this.decimal === null)
            this.decimal = this.defaultDecimal;
        if (this.roundType === null)
            this.roundType = this.defaultRoundType;
    };
    return FxNumberFormatComponent;
}(AbstractDwFormItemComponent));
export { FxNumberFormatComponent };
